import { TypingIds } from "components";

export default function DynamicLink() {
  const ids = [
    "emily26",
    "selenagomezz",
    "gataastudio",
    "robert_m",
    "david_bekhamm",
    "what's your favorite ID?",
  ];
  const hostname = window.location.hostname;
  return (
    <section className="w-full space-y-1.5 mt-7 lg:mt-10">
      <p className="w-full text-center text-lg lg:text-[1.75rem] text-dark font-medium font-gilroy">
        {hostname}/
        <TypingIds ids={ids} className="text-[#798BB4]" />
      </p>
      <p className="w-full text-center text-lg lg:text-base text-dark font-medium font-gilroy">
        +10000 more users
      </p>
    </section>
  );
}
